import config from 'application-config';

/**
 * How the editor saves the latest story, set per environment by `storySaveMechanism` at build time.
 * A missing key means `snapshot`: whole-story autosave. See docs/specs/story-edit-operations.md.
 */
export const isEditOperationsSave: boolean = config.storySaveMechanism === 'edit-operations';
